export default {"src":"/_next/static/media/harmony.af12f77e.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};